module.exports = __webpack_public_path__ + "img/17.19ee4c4a.jpg";